import BaseService from './BaseService'
import entities from 'src/config/entities'

class SubscriptionService extends BaseService {

  constructor() {
    super({entity: entities.SUBSCRIPTION});
  }

  async filterSubscriptions({ client_id } = {}) {
    let filters = [
      {
        "field": "amount",
        "value": 1,
        "operator": ">="
      },
    ]
    if (client_id) {
      filters.push(
        {
          "field": "client_uuid",
          "operator": "IS",
          "value": client_id
        }
      )
    }
    let data = {
      filters,
      "sort": {
        "page": 1,
        "limit": 20,
        "order": {
          "created_at": "desc"
        }
      },
      "withs": [
        "client",
        "order",
        "product_job_board",
        "product_job_board.job_board"
      ]
    }
    return this.instance.post(`/filter`, data)
  }

}

export default new SubscriptionService();
